class ScrollToTags {
  constructor() {
    const params = new URLSearchParams(window.location.search);
    this.filter = document.querySelector(".taxonomyFilter");
    if (params.has('tag') && this.filter) {
      const activeTag = document.querySelector(`[value="${params.get('tag')}"]`)
      activeTag.classList.add('button--active')
      this.hideAndShowEvents(params.get('tag'))
      this.filter.scrollIntoView({behavior: 'smooth', block: 'center'});
      return;
    }
  }

  hideAndShowEvents(tag) {
    const events = this.filter.parentElement.querySelectorAll('.eventItem');
    events.forEach(event => {
      if (event.getAttribute('data-tag') === tag) {
        event.style.display = "grid"
      } else {
        event.style.display = "none"
      }
    })
  }
}

export default ScrollToTags;